
Greenmile.RouteProgress = Greenmile.RouteProgress || {};
Greenmile.RouteProgress.Request = function () {

    this.filter = function (data) {

        var pagination = App.Forms.RouteProgress.pagination;
        var callback;

        Greenmile.RouteProgress.data = data;

        if (pagination.first === 0) {
            callback = Monet.Grid.addDataToGrid;
        } else {
            callback = Monet.Grid.appendDataToGridAfterPagination;
        }

        App.Views.RouteProgress.createGrid(callback);

    };

};